import { render, staticRenderFns } from "./Colegiaturas.vue?vue&type=template&id=3dc8ec7c&scoped=true"
import script from "./Colegiaturas.vue?vue&type=script&lang=js"
export * from "./Colegiaturas.vue?vue&type=script&lang=js"
import style0 from "./Colegiaturas.vue?vue&type=style&index=0&id=3dc8ec7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8ec7c",
  null
  
)

export default component.exports